const collaborateTypes = {
  OPEN_MODAL_JOIN_CHART: 'OPEN_MODAL_JOIN_CHART',
  CLOSE_MODAL_JOIN_CHART: 'CLOSE_MODAL_JOIN_CHART',
  OPEN_MODAL_SHARE_CHART: 'OPEN_MODAL_SHARE_CHART',
  CLOSE_MODAL_SHARE_CHART: 'CLOSE_MODAL_SHARE_CHART',
  UPDATE_COLLABORATORS: 'UPDATE_COLLABORATORS'
}

export default collaborateTypes
